import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";

function NotificationDetail() {
  const [notification, setNotification] = useState(null);
  const { id } = useParams();

  useEffect(() => {
    const fetchNotification = async () => {
      try {
        const response = await fetch(`/api/profile_actions/notification/${id}/`);
        const data = await response.json();
        setNotification(data);
      } catch (error) {
        console.error("Error fetching notification:", error);
      }
    };

    fetchNotification();
  }, [id]);

  if (!notification) {
    return <div>Loading...</div>;
  }

  return (
    <div>
      <h1>Notification Detail</h1>
      <p>{notification.verb}</p>
      <p>{notification.timestamp}</p>
    </div>
  );
}

export default NotificationDetail;